<template>
	<div class="itempage" style="background: #fff;">
		<el-card style="position: relative;padding-bottom: 10px;">
			<div style="font-size: 16px;"><b>{{ $t('message.title.list') }} : </b> {{ listName }}</div>
		</el-card>

		<!-- tab切换 -->
		<div class="tab">
			<el-tabs v-model="activeName" @tab-click="handleClick" style="padding-left:15px;height:56px">
				<el-tab-pane v-for="(item, index) in tabList" :label="item.label" :key="index" :name="index + ''"></el-tab-pane>
			</el-tabs>

			<GerenalInfo v-show="this.activeName == 0" :listInfo='listId' @change='getListName'>
			</GerenalInfo>
			<div v-show="this.activeName == 1" style="padding:0 16px">
				<!-- 普通列表 -->
				<Simple v-if="listType == 1 || listType == 3" :listUsed='listUsed'></Simple>
				<!-- 瀑布(级联)列表 -->
				<Cascade v-if="listType == 2" :listUsed='listUsed'></Cascade>
				<!-- 编码列表 ，序列号列表，版本号列表-->
				<CodeList v-if="[4, 5, 6].includes(listType)" :listUsed='listUsed'></CodeList>
				<!-- 引用列表 -->
				<Simple v-if="listType == 7" :listUsed='listUsed'></Simple>
			</div>
			<ListsWhereUsed v-show="this.activeName == 2" @updateListUsed='updateListUsed'>
			</ListsWhereUsed>


		</div>
	</div>

</template>


<script>
import axios from "axios";
import Simple from './components/ListType/simple.vue';
import CodeList from './components/ListType/codeList.vue';
import ReferenceList from './components/ListType/referenceList.vue';
import ListsWhereUsed from './components/ListType/listsWhereUsed.vue';
import Cascade from './components/ListType/cascade.vue';
import GerenalInfo from './components/General.vue/gerenalInfo.vue';
export default {
	components: { Simple, Cascade, GerenalInfo, CodeList, ReferenceList, ListsWhereUsed },
	name: 'ListInfo',
	data() {
		return {
			listUsed: '0',	//这个list是否被使用
			activeName: '1',
			listId: JSON.parse(this.$route.query.row),
			listName: JSON.parse(this.$route.query.row).name,
			listType: JSON.parse(this.$route.query.row).listType,
			// allListNames:this.$route.query.listNames,
			tabList: [
				{ label: this.$t('message.title.baseInfo') },
				{ label: this.$t('message.title.listVal') },
				{ label: this.$t('message.title.listWhereUsed') }
			],

			tab1_show: true,
			tab2_show: false,


			old_grid_data: {},

			editShow: false,


			created_1: true,
			old_data: {},
			editForm: {
				name: "",
				listType: "1",
				description: "",
				enabled: "1",
				// displayType: "1",
			},
			num: 0,
			input_width: {},

			loading: true,

			tab_all_id: [{ //公用tabid
				id: 1010101,
				classId: 101,
				name: this.$t('message.title.baseInfo'),
				path: "/titleBlock"
			}, {
				id: 1010102,
				classId: 101,
				name: this.$t('message.title.listVal'),
			}],


		}
	},
	methods: {
		handleClick(tab, event) {
			// console.log(tab, event);
			// console.log(this.activeName);
			// console.log(this.listType);
		},
		dblclick({ row }) { },
		updateListUsed(e) {
			this.listUsed = '1';
			// console.log(this.listUsed);
		},
		getListName(e) {
			this.listName = e;
			this.$emit('update', e);
		},
		getTab2List() {
			axios.get('/pmdm/admin/list/getListEntries?listId=' + this.$store.state.listId)
				.then(res => {
					if (res.data.code == 200) {
						this.gridOptions.data = res.data.object.listEntries;
						this.old_grid_data = res.data.object.listEntries;
					}
				})
				.catch(function (error) {
					console.log(error);
				});
		},

		cc() {
			let obj = {}
			axios.post('/pmdm/admin/list/saveMultistageList', obj)
		},

	},
	created() {
		console.log(this.$route.query);
		setTimeout(() => {
			this.loading = false;
		}, 500);
	}
}
</script>

<style>
.tab {
	margin-top: 15px;
}

.tab .el-tabs__item.is-active {
	color: #409eff;
}

.tab .el-tabs__item {
	padding: 0 20px;
	height: 40px;
	box-sizing: border-box;
	line-height: 40px;
	display: inline-block;
	list-style: none;
	font-size: 16px;
	font-weight: 500;
	color: #303133;
	position: relative;
}

.tab .el-tabs__item {
	background: none;
	border-left: none !important;
	font-size: 16px !important;
	border-radius: 0 !important;
}

.tab .el-tabs__item.is-active {
	background: none !important;
}



.table-list li {
	overflow: hidden;
	margin-bottom: 6px;
}

.table-list .list-key {
	display: inline-block;
	width: 42%;
	text-align: right;
	font-size: 14px;
}

.table-list .list-val {
	display: inline-block;
	width: 52%;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	line-height: 18px;
	font-size: 14px;
	position: relative;
	top: 3px;
}

.table-list .list-key-1 {
	display: inline-block;
	width: 18.5%;
	text-align: right;
	font-size: 14px;
}
</style>

<style scoped>
.btn {
	display: inline-block;
	padding: 4px;
	padding-right: 10px;
	border: 1px solid #000;
	border-radius: 3px;
	cursor: pointer;
	margin-left: 8px;
	font-size: 14px;
}

.btn i {
	display: inline-block;
	width: 18px;
	height: 18px;
	position: relative;
	top: 3px;
	font-size: 14px;
}

.btn span {
	position: relative;
	padding: 0 2px;
}


.btn img {
	height: 100%;
	width: 100%;
}

.btn1 {
	height: 32px;
	color: #4b92ff;
	border-color: rgba(75, 146, 255, 0.5);
	background: rgba(75, 146, 255, 0.2);
	margin-left: 20px;
}

.btn1:hover {
	color: #fff;
	background: rgba(75, 146, 255, 0.4);
}

.btn2 {
	height: 32px;
	color: #fe6263;
	border-color: rgba(254, 98, 99, 0.5);
	background: rgba(254, 98, 99, 0.2);
}

.btn2:hover {
	color: #fff;
	background: rgba(254, 98, 99, 0.4);
}

.content-title {
	padding: 0;
	margin: 0;
	overflow: hidden;
	background-size: 100% 100%;
	margin-left: 20px;
	height: 57px;
}

.content-title li {
	float: left;
	padding: 18px 12px 12px 12px;
	font-size: 16px;
	cursor: pointer;
	margin-right: 18px;
}

.content-title li:hover {
	border-bottom: 3px solid #4b92ff;
	color: #4b92ff;
}

.content-title .active {
	border-bottom: 3px solid #4b92ff;
	color: #4b92ff;
}

.btn7 {
	height: 32px;
	color: #4b92ff;
	border-color: rgba(75, 146, 255, 0.5);
	background: rgba(75, 146, 255, 0.2);
}

.btn7:hover {
	color: #fff;
	background: rgba(75, 146, 255, 0.4);
}

.btn8 {
	height: 32px;
	color: #fe6263;
	border-color: rgba(254, 98, 99, 0.5);
	background: rgba(254, 98, 99, 0.2);
}

.btn8:hover {
	color: #fff;
	background: rgba(254, 98, 99, 0.4);
}
</style>